module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-light-webfont.45c5e749.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-light-webfont.ttf
// module id = 364
// module chunks = 3